import "./Button.style.css";

import React, { ReactElement, Ref } from "react";

export enum ButtonColor {
  Primary = "primary",
  Secondary = "secondary",
  Accent = "accent",
  Shiny = "shiny",
  Border = "border",
  Empty = "empty",
}

export enum ButtonSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export enum ButtonType {
  Button = "button",
  Reset = "reset",
  Submit = "submit",
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  color?: ButtonColor;
  size?: ButtonSize;
  type?: ButtonType;
  icon?: ReactElement;
  disabled?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

export const Button = ({
  text,
  color = ButtonColor.Primary,
  size = ButtonSize.Medium,
  type = ButtonType.Button,
  icon,
  disabled = false,
  className = "",
  style = {},
  ...rest
}: ButtonProps) => {
  const buttonClasses =
    `btn btn_${size} btn_${color} ${!text ? "btn_no-text" : ""} ${!icon ? "btn_no-icon" : ""} ${className}`
      .trim()
      .replace(/\s+/g, " ");

  const buttonAttributes: React.ButtonHTMLAttributes<HTMLButtonElement> = {
    type: type,
    disabled: disabled,
    className: buttonClasses,
    style: style,
  };

  return (
    <button {...rest} {...buttonAttributes}>
      {icon}
      {text && <span className="btn__text">{text}</span>}
    </button>
  );
};
